import Vue from "vue";
import base from "../../baseMarketing";

export default Object.assign(
    {
        apiUrl: "/whatsapp/config/",

        async get({ accountId }) {
            const url = this.url(accountId);
            return Vue.http.get(url);
        },

        async createForm({ accountId, companyEmail, companyName, headQuarterCountry, isAutoGenerateNumber, metaBusinessManagerId, vertical, website }) {
            const url = this.url(accountId);

            return Vue.http.post(url, {
                companyEmail,
                companyName,
                headQuarterCountry,
                isAutoGenerateNumber,
                metaBusinessManagerId, vertical,
                website
            });
        },

        async editForm({ accountId, companyEmail, companyName, headQuarterCountry, isAutoGenerateNumber, metaBusinessManagerId, vertical, website }) {
            const url = this.url(`${accountId}/form`);

            return Vue.http.put(url, {
                companyEmail,
                companyName,
                headQuarterCountry,
                isAutoGenerateNumber,
                metaBusinessManagerId, vertical,
                website
            });
        },

        async editCredentials({accountId, authToken, sourceId, subAccountId }) {
            const url = this.url(accountId);

            return Vue.http.put(url, {
                authToken,
                sourceId,
                subAccountId,
            });
        },

        async updateStatus({ accountId, status }) {
            const url = this.url(`${accountId}/status/${status}`);

            return Vue.http.patch(url);
        },
    },
    base
);
